import type { ReportTag } from "@/api/types";

/**
 * A tag as a picker or a table names it. A company's own tag (ADR-0065) reads under its parent, "Operating › Employee
 * benefits expense › Staff welfare", so it can't be mistaken for a supplied one.
 */
export function tagLabel(tag: ReportTag, tags: readonly ReportTag[]): string {
  if (!tag.parentCode) return tag.label;
  const parent = tags.find((other) => other.code === tag.parentCode);
  return parent ? `${parent.label} › ${tag.label}` : tag.label;
}

/** The tags that can be chosen: an archived company tag isn't offered, unless it's the one already chosen. */
export function offered(tags: readonly ReportTag[], keep?: string | null): ReportTag[] {
  return tags.filter((tag) => !tag.archived || tag.code === keep);
}
